module.exports = __webpack_public_path__ + "static/media/Statua_038.80a40a12.jpg";